<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="vx-row form">
 <div class="vx-col w-full lg:w-2/3 " v-scrollanimation v-appear:left="{ delay: 100 * 4 }">
      <vx-card title="" >
<h1>Vendez votre logement avec nous </h1>
    <div v-if="created" >
      <br>
      <br>
      <h3>Egayez vos annonces avec des images</h3>
          <b-form-file
      v-model="files"
      :state="Boolean(files)"
      multiple
      placeholder="Choissisez vos images"
      drop-placeholder="Drop file here..."
    ></b-form-file>
    <br>
    <br>
     <b-row v-if="files" class="list-inline p-6">
            <b-row>
              <b-col cols="8">
                   <h5>Ordonner les images de votre annonce suivant l'ordre d'affichage</h5>
              </b-col>
              <b-col cols="4">
                  <img
              src="@/assets/images/anim.gif"
             
              width="200"
            />
              </b-col>
            </b-row>
           
              
            <draggable
              v-model="files"
              group="people"
              @start="drag = true"
              @end="drag = false"
              class="row wrap fill-height align-center sortable-list"
            >
              <b-col
                sm="4"
                md="4"
                lg="4"
                xl="4"
                v-for="(item, index) in files"
                :key="index"
                :index="index"
                :item="item"
                class="row-v p-2"
              >
                <b-card
                  no-body
                  bg-variant="light"
                  :img-src="previewImage(item)"
                  img-alt="Image"
                  img-height="350"
                  img-width="350"
                  class="overflow-hidden h-100 movePic"
                >
                <div
                class="bottom-left text-white text-capitalize h3 font-weight-bold"
              >
                {{files.indexOf(item)}}
              </div>
                </b-card>
                <!-- <b-img fluid :img-src="previewImage(item)" h-100></b-img> -->

                <!-- <b-img
                        thumbnail
                        fluid
                        :src="previewImage(item)"
                        alt="Image 1"
                        height="5000px"
                      ></b-img>  -->
              </b-col>
              <br />
            </draggable>
          </b-row>
    <br>
    <vs-button @click="upload()">Envoyer</vs-button>
    </div>
    <div class="mt-5">
      <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit" v-if="!created">
        <div v-if="loadingRelated" class="d-flex justify-content-center mb-3">
    <b-spinner label="Loading..."></b-spinner>
  </div>
        <tab-content title="Step 1" class="mb-5" icon="feather icon-home" :before-change="validateStep1">

          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
               <b-form-group
          label="Pays"
          
        >
         </b-form-group>
         <b-form-input label ="Pays" list="my-list-id" v-model="userCountry"></b-form-input>

                    <datalist id="my-list-id" >
                      
                      <option v-for="userCountry in countries" :key="userCountry" >{{ userCountry }}</option>
                    </datalist>
                    
                    <span class="text-danger">{{
                      errors.first("step-1.country")
                    }}</span>
          
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Ville"  v-model="userTown" class="w-full mt-4" name="usertown" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-1.town') }}</span>
              </div>
            </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Adresse " v-model="userAdress" class="w-full" name="userAdress" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-1.userAdress') }}</span>
            </div>
    
          </div>
          </form>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Step 2" class="mb-5" icon="feather icon-briefcase" :before-change="validateStep2">
          <form data-vv-scope="step-2">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
             <vs-input label="Nom"  v-model="userHomeName" class="w-full mt-4" name="userHomeName" v-validate="'required'" />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vs-select v-model="userLogementType" class="w-full select-large" label="Type de logement">
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in logementType" class="w-full" />
              </vs-select>
           
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-textarea v-model="userHomeDescprition" label="Description courte" class="md:mt-10 mt-6 mb-0" rows="3" />
            </div>
          </div>
          </form>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content title="Step 3" class="mb-5" icon="feather icon-image" :before-change="validateStep3">
          <form data-vv-scope="step-3">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input type="number" label="Combien de chambres la maison dispose ?" v-model.number="userBedroom" class="w-full mt-5" name="userBedroom" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-3.userBedroom') }}</span>
            </div>
    
             <div class="vx-col md:w-1/2 w-full">
              <vs-input type="number" label="Combien de salle de bains la maison dispose ?" v-model.number="userBathroom" class="w-full mt-5" name="userBathroom" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-3.userBathroom') }}</span>
            </div>
          
          </div>
          <br>

          <div class="vx-row">
             <div class="vx-col md:w-1/2 w-full">
              <vs-input label="Prix " type ="number" v-model.number="userPrice" class="w-full mt-5" name="userPrice" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-3.userPrice') }}</span>
             </div>
          </div>
         
          </form> 
        </tab-content>
      </form-wizard>
    </div>

   
  </vx-card>
  </div>
  <div class="vx-col lg:w-1/3">
   <vx-card class="overflow-hidden unique">
       
    </vx-card> 
  </div>
</div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from '@/helpers/axios'
import draggable from 'vuedraggable'


// For custom error message
import { Validator } from 'vee-validate'
const dict = {
  custom: {
    userAdress: {
      required: 'L\'adresse est requise',
      alpha: 'Doit commencer par une lettre majuscule'
    },
    name: {
      required: 'Le nom pour l\'annonce est requise',
      alpha: 'Last name may only contain alphabetic characters'
    },
    visitor: {
      required: 'Le nombre de visiteurs est requis',
      visitor: ''
    },
    country: {
      required: 'Votre pays est requis',
      alpha: ''
    },
    town: {
      required: 'Votre ville est requise',
      alpha: ''
    },
    userBathroom: {
      required: 'Le nombre de douches est requis',
      alpha: ''
    },
    userBedroom: {
      required: 'Le nombre de chambres est requis ',
      alpha: ''
    },
    userBed: {
      required: 'Le nombre de lits est requis ',
      alpha: ''
    }
  }
}

// register custom messages
Validator.localize('fr', dict)

export default {
  data () {
    return {
      countries: [],
      files :null,
      created : false,
      idCreated : '',
      loadingRelated:false,
      userHomeName:'',
      userHomeDescprition :'',
      userTown :'',
      userCountry :'',
      userAdress :'',
      userLogementType :'',
      userPrice : 0,
      userBed : 0,
      userBedroom : 0,
      userBathroom : 0,
      userDateBegin :'',
      logementType: [
        'Appartement',
        'Maison',
        'Logement unique',
        'Logement proche',
        'Chambre d\'hôtes' 

      ],
      
      equipements: [
        'Wi-Fi',
        'Télévision',
        'Chauffage',
        'Climatisation',
        'Fer à repasser' 

      ],
      security:[
        { text: 'Extincteur', value: 'new-york' },
        { text: 'Kit de premier secours', value: 'chicago' },
        { text: 'Porte de la chambre avec verrou', value: 'san-francisco' }
        

      ]
    }
  },
  methods: {
    async loadListOfcountries () {
      if (this.$store.state.listOfCountries.length === 0) {
        let listOfcountries = []
        listOfcountries = await axios.get('https://restcountries.eu/rest/v2/all').then((response) => {
          response.data.forEach((item) => (
            listOfcountries.push(item.translations.fr)
          ))
          return listOfcountries
        })
       
        this.$store.commit('UPDATE_LIST_OF_COUNTRIES', listOfcountries, { root: true })
        this.countries = await this.$store.state.listOfCountries
        
      }
      
    },
    previewImage (file) {
      if (file) {
        this.imagePreviewURL = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
        return this.imagePreviewURL // free memory
      } else {
        return null
      }
    },
    upload () {
      const data = new FormData()
      this.files.forEach(file => {
        data.append('image', file)
      })
      axios.post(`/home/sale/${this.idCreated}/upload_images`, data).then(() => {
        this.$router.push('/home/sell').catch(() => {})
      })
    },
    validateStep1 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateStep2 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-2').then(result => {
          if (result) {
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    validateStep3 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-3').then(result => {
          if (result) {
      
            axios.post('/home/sale',
              {
                'bedroom' : this.userBedroom,
                'bathroom' : this.userBathroom,
                'price' : this.userPrice,
                'equipement' : this.userEquipements,
                'description' : this.userHomeDescprition,
                'owner':{
                  'email':this.$store.state.AppActiveUser.email
                },
                'home':{
                  'name':this.userHomeName,
                  'adress': this.userAdress,
                  'town':this.userTown,
                  'country':this.userCountry,
                  'category':this.userLogementType

                }
              } 
            )
              .then((data) => {
                if (data) {
                  this.created = true
                  this.idCreated = data.data
                
                }
              })
              .catch(() => {
              })
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    }
  },
  components: {
    FormWizard,
    TabContent,
    draggable
  },
  mounted () {
    this.loadListOfcountries()
  }
}
</script>
<style >
.unique
  {
    min-height: 34rem;
       background-image: url('../../../../assets/images/pages/home/carousel/26.jpg');
       background-position: center;
    background-size: cover;
  }
  .form{
    padding:10px
  }
  .movePic:hover {
  cursor: move;
}
  .bottom-left {
  color: white;
  position: absolute;
  top: 95%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  width: 100%;
  height: 20%;
  padding: 10px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  text-align: center;
  background-color: #f0b104;
}
</style>